
class Constants {
    static noValue = "——";

    static systemModules = {
        PDP: "PDP",
        PLP: "PLP",
        Quote: "QUOTE",
        BOM: "BOM",
        CART: "Cart",
        CHECKOUT: "CheckOut",
        COMPARE: 'COMPARE'
    }
    static cpnTypes = {
        CPN: "CPN",
        MANUALCPN: "ManualCPN",
    }

    static checkOutSteps = {
        ADDRESS_STEP: "address_step",
        METHOD_STEP: "method_step",
        PAYMENT_STEP: "payment_step"
    }

    static taxExempt = {
        EXEMPT: "Exempt",
        OVERWRITE: "Overwrite",
        NONE: "None"
    }

    static cartSummary = {
        SUBTOTAL: "subTotal",
        ORDERTOTAL: "orderTotal",
    }
    static currencyType = {
        USD: "USD",
        CAD: "CAD",
    }

    static CartType = {
        SHOPPING: "Shopping",
    }
    static addressType = {
        BILL_TO: "BillTo",
        SHIP_TO: "ShipTo",
    }

    static countryCodes = ["JP", "PR", "US", "CN", "CA"]
    static countryNames = {
        "Japan": "JP",
        "Puerto Rico": "PR",
        "United States": "US",
        "China": "CN",
        "Canada": "CA"
    }

    static salesOrgC001 = 'C001';

    static numericPattern = /^[0-9-+()\/]*$/;
    static mobilePattern = /^[0-9\s()+\-.,]*[0-9]+[0-9\s()+\-.,]*$/;
    static onlyNumberPattern = /^[0-9]*$/;
    static companyNamePattern = /^[a-zA-Z0-9 ~!$%^&\-_=+{}\[\]|:<>.,||俊容洪šž辉季áí赵凯济同张丁弘ň()段超琼ğ康云宝öüélèáís*i陈华景å'ü@éø李金成JÃƒÂ¶rgłD´ŻÃ©|ÖMÃƒÆ’Ã‚Â¶Â¼hle#?]*$/;
    static onlyStringPattern = /^[a-zA-Z ]+$/;
    static addressPattern = /^[A-Za-z0-9 &*#'_\\\-,.()\/]+$/;
    static alphaNumericPatternWithSpace = /^[a-zA-Z0-9 ]*$/;
    static purchaseOrderNumberPattern = /^[0-9a-zA-Z\-\/\\ ]+$/;
    static validateQtyMsg = "Please provide different quantity values."
    static downloadMsg = "The document successfully downloaded. Please check your computer or new browser window for the document.";
    static emailPattern = /^([A-Za-z\u00C0-\u017F0-9_\-\.])+\@([A-Za-z\u00C0-\u017F0-9_\-\.])+\.([A-Za-z\u00C0-\u017F]{2,4})$/;
    static internalUsers = ["ebv.com", "avnet.eu", "silica.com", "avnet-abacus.eu", "abacus.co.uk",
        "avnet-embedded.eu", "avnet.com", "AVNETTIME.EU", "avnet-memec.eu", "avnet.abacus.eu", "softwebsolutions.com"]
    static zipCodePattern = /^[A-Za-z0-9 &*#'_\\\-,.ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßsLàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿĀāĂăĄąĆćĈĉĊċČčĎďĐđĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħĨĩĪīĬĭĮįİıĲĳĴĵĶķĸĹĺĻļĽľĿŀŁłŃńŅņŇňŉŊŋŌōŎŏŐőŒœŔŕŖŗŘřŚśŜŝŞşŠšŢţŤťŦŧŨũŪūŬŭŮůŰűŲųŴŵŶŷŸŹźŻżŽžſ\/]+$/;
    // static numericWithSpecialChar = /^[a-zA-Z0-9]+$/;
    static alphaNum = /^[\d()+\-\/\s]{1,20}$/;

    static adminConsoleTab = {
        User: "users",
        Account: "accounts",
        Report: "reports",
    }
    static roles = [
        { value: 'ZI', label: 'ZI' },
        { value: 'ZX', label: 'ZX' },
        { value: 'ZU', label: 'ZU' }
    ]
    static userType = {
        INTERNAL: 'Internal',
        EXTERNAL: 'External'
    }
    static countryTariff = {
        BrazilTariff: 'BrazilTariff',
        NonBrazilTariff: 'NonBrazilTariff'
    }
    static errorCode = "UserExist001"

    static orderPayload = {
        orderNumber: "orderNumber",
        poNumber: "poNumber",
        invoiceNo: "invoiceNo",
        trackingNo: "trackingNo",
        releaseNo: "releaseNo",
        orderType: "orderType",
        orderStatus: "orderStatus",
        manufacturerPartNumber: "manufacturerPartNumber",
        customerPartNumber: "customerPartNumber",
        manufacturerName: "manufacturerName",
        deliveryDate: "deliveryDate",
        scheduleDate: "scheduleDate",
    }

    static speedBoats = {
        AMERICA: "America",
        americaAbbr: "G",
        US: 'us',
        AMERICAS: 'americas'
    }

    // value shold be which in available in "avUSerInfo"
    static userInfoKey = {
        USERNAME: "UserName",
        SPEEDBOAT: "speedboat",
        EMAIL: "email",
        ACCOUNTNUMBER: "accountNumber",
        ACCOUNTNAME: "accountName",
        ROLES: "roles",
        SPEEDBOATNAME: "speedboatName",
        SALESORG: "salesOrg",
        ORDERBLOCK: "orderBlock",
        DEFAULTSHIPTO: "defaultShipTo",
        CURRENTSHIPTO: "currentShippingAddress"
    }

    static homePageAllTabs = {
        PRODUCT: {
            tabHeader: "Products",
            countTab: "productCount",
            abbr: "PLT"
        },
        NPI: {
            tabHeader: "New Product Information",
            contentType: 'NPI',
            content: "NPI",
            countTab: "npiCount",
            abbr: "NPIT"
        },
        CONTENT: {
            tabHeader: "Content",
            countTab: "allContentCount",
            abbr: "CNT"
        },
        ALLCONTENT: {
            tabHeader: "All Content",
            contentType: 'All',
            content: "AllContent",
            countTab: "allCount",
            abbr: "ALCT"
        },
        ARTICLE: {
            tabHeader: "Articles",
            contentType: 'articles',
            content: "Articles",
            countTab: "articleCount",
            abbr: "ACL"
        },
        EVENT: {
            tabHeader: "Events",
            contentType: 'events',
            content: "Events",
            countTab: "eventCount",
            abbr: "EVT"
        },
        SITE: {
            tabHeader: "Site pages",
            contentType: 'sitePages',
            content: "SitePage",
            countTab: "siteCount",
            abbr: "SITE"
        },
        VIDEO: {
            tabHeader: "Videos",
            contentType: 'video',
            countTab: "videoCount",
            abbr: "VDO",
            pageType: "Brightcove-Videos"
        },
        DOCUMENT: {
            tabHeader: "Documents",
            countTab: "documentCount",
            abbr: "DCT"
        }
    };

    static bomDetailPageTabs = {
        BomExactMatchTable: {
            tabHeader: "Exact Match",
            content: "BomExactMatchTable",
            api_fetch_type: "Exact"
        },
        BomMultipleMatchTable: {
            tabHeader: "Multiple Match",
            content: "BomMultipleMatchTable",
            api_fetch_type: "Multiple"
        },
        BomNoMatchTable: {
            tabHeader: "No Match",
            content: "BomNoMatchTable",
            api_fetch_type: "NoMatch"
        },
    }

    static BomPages = {
        CreateBom: { param_value: 'CreateBom' },
        BomTabsList: { param_value: 'BomTabsList' },
        BomRematch: { param_value: 'BomRematch' },
        BomProductListing: { param_value: 'BomProductListing' },
        BomDetailById: { param_value: 'BomDetailById' },
    };

    static AlertPages = {
        PCN: {
            param_value: 'PCN'
        },
        EOL: {
            param_value: 'EOL'
        }
    };

    static QuoteTabList = {
        APR: {
            name: 'APPROVED',
            param_value: 'APR'
        },
        PND: {
            name: 'PENDING',
            param_value: 'PND'
        },
        NBD: {
            name: 'NO BID',
            param_value: 'NBD'
        },
        BKD: {
            name: 'BOOKED',
            param_value: 'BKD'
        }
    };

    static ProfileTab = {
        ProfileInfo: "ProfileInformation",
        AddressBook: "AddressBook",
        Contact: "MyAvnetContacts",
    }


    static siteUser = {
        GUEST: "Guest",
        WEB: "Web",
        CORE: "Core"
    }

    static QuotePages = {
        QuoteHeaderDetail: { param_value: 'QuoteHeaderDetail' },
        QuoteListing: { param_value: 'QuoteListing' },
        QuoteAddress: { param_value: 'QuoteAddress' },
        OpenQuoteListing: { param_value: 'OpenQuoteListing' },
        QuoteDetail: { param_value: 'QuoteDetail' }
    };

    static LifeCycleRisk = {
        LOW: "Low",
        MED: "Med",
        HIGH: "High"
    }

    static DescriptionLength = {
        More: "more",
        Less: "less"
    }

    static QuantityAction = {
        Minus: "minus",
        Plus: "plus"
    }

    static PriceType = {
        YARS: 'YARS',
        ZREC: 'ZREC'
    }

    static PreferenceType = {
        Default_Account: "Default_Account",
        Default_ShipTo: "Default_ShipTo",
        Default_BillTo: "Default_BillTo",
        Default_Carrier: "Default_Carrier",
        Download_Bom_Columns: "Download_Bom_Columns",
        Download_Forecast_FileType: "Download_Forecast_FileType"
    }

    static FactoryLeadTime = [null, undefined, '', 0, '0', "777", "555", "180", "999", "994", 777, 555, 180, 999, 994, "Yes", "yes", "YES", "No", "no", "NO"];

    static Distributor = {
        AVNET: "AVNET",
        NEWARK: "NEWARK",
        WALDOM: "WALDOM",
        ROCHESTER: "ROCHESTER",
        FLIP: "FLIP"
    }

    static shippingAddressType = {
        CountryCode: {
            US: "US",
            CA: "CA",
        },
        StateCode: {
            CA: "CA"
        },
        Type: {
            DOMESTIC: "DOMESTIC",
            INTERNATIONAL: "INTERNATIONAL",
            CANADA: "CANADA",
        }
    }

    static paymentType = {
        CreditCard: 'CreditCard',
        AvnetCredit: 'AvnetCreditLine',
    }
    static shippingCarrierType = {
        MANUAL: 'MANUAL',
        AVNET: 'AVNET',
        FREESHIP: 'FreeShip',
    }
    static avnetCarrierType = {
        FEDEX: 'fedEx',
        UPS: 'ups',
        DHL: 'dhl',
    }

    // static Months = [
    //     "January", "February", "March", "April", "May", "June",
    //     "July", "August", "September", "October", "November", "December"
    // ];
    static AdminComplianceOptions = {
        orderNumber: "Web Order Number",
        customerNumber: "Customer Number",
        customerName: "Customer Name",
    }

    static AdminOrderOptions = {
        WebOrderNumber: "Web Order Number",
        SalesOrderNumber: "Sales Order Number",
        OrderState: "Order State",
        AccountNumber: "Account Number",
        CustomerLoginId: "Customer Login ID",
    }

    static AdminOrderState = {
        PendingAuth: "Pending Auth",
        Ready: "Ready",
        Sent: "Sent",
        Confirmed: "Confirmed",
        Rejected: "Rejected",
        Error: "Error",
        Hold: "Hold",
        Blocked: "Blocked",
    }

    static adminOrderEditEligibleStatus = ["PendingAuth", "Blocked", "Error", "Rejected","Hold"]

    static TaxExemptFormURL = 'https://www.avnet.com/wcsstore/AvnetSAS/version_v06072024/StaticContent/Tax_Template.pdf'

    static fileUploadSuccess = 'Upload Successful! Your file has been uploaded successfully'

    static ACCOUNTINACTIVE = "accountInactive"
    static INVALIDSUPPLIER = "invalidSupplier"
    static INTERNALUSER = "internalUser"
    static INVALIDMANUFACTURER = "invalidManufacturer"
    static RESTRICTEDCOUNTRY = "restrictedCountry"
    static paymentError = "paymentError"
    static CARTEOLOBSOLETE = "cartContainsEOLObsolete"
    static PRODUCT_UNAVAILABLE = "cartProductUnavailable"

    static Restricted_Countries = ['UA', 'RU', 'BY']

    static OrderPages = {
        OrderHistory: {
            name: 'OrderHistory',
            param_value: 'OrderHistory'
        },
        OrderDetail: {
            name: 'OrderDetail',
            param_value: 'OrderDetail'
        }
    }

    static OrderDetailTabList = {
        BY_SHIPMENT: {
            name: 'BY SHIPMENT',
            param_value: 'BY_SHIPMENT'
        },
        BY_LINE_ITEMS: {
            name: 'BY LINE ITEMS',
            param_value: 'BY_LINE_ITEMS'
        },
    };

    static pathNameAmericasCookie = "pathNameAmericas" // DX Cookie Name

    // Avnet Credit Line option is not shown to the user/account with payment term from below list
    static paymentTerms = ['911', '917', '997', '9J6', '9l8', '935',]

    static PDFQuoteLink = 'https://images.avnet.com/opasdata/fsp/quoting-help.pdf'

    static CognitiveSearchFieldConfig = {
        FamilyName: 'FamilyName',
        ManufacturerName: 'ManufacturerName',
        flagFacets: 'flagFacets',
        Categories: 'categories',
        attributes: 'attributes',
        normal: 'normal'
    };

    static analyticsEvent = {
        BOM_OPENED:'bomOpened',
        ADD_NEWARK_ITEM: 'addItemsToNewark'
    }
    static agGridLicenseKey = "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-076353}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Avnet,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{8_April_2026}____[v3]_[0102]_MTc3NTYwMjgwMDAwMA==3018d0b5d5bf8c9157a79b1cae7a1968"
    
    static quote = "Quote"
}

export default Constants;